module.exports = __webpack_public_path__ + "img/cxy.6d5c7581.png";